<template>
    <div>
        <LaPageHeader :heading="$mq.min.desktop ? 'Account' : heading">
            <template #controls>
                <portal-target name="accountControls" />
            </template>
        </LaPageHeader>
        <BaseCard>
            <div class="p-0 account-content-full">
                <LaPageHeader :heading="heading" v-if="$mq.min.desktop" />
                <router-view />
            </div>
        </BaseCard>
    </div>
</template>

<script>
import { computed } from "vue";
import { useRoute } from "vue-router";
import BaseCard from "@/components/BaseCard";
import LaPageHeader from "@/components/PageHeader";

export default {
    name: "LaAccountView",
    components: {
        BaseCard,
        LaPageHeader,
    },
    setup() {
        const route = useRoute();
        const heading = computed(() => route.meta.label);
        return { heading };
    },
};
</script>

<style lang="scss">
.account {
    &-content-full {
        width: 100%;
    }
}
</style>
